import { ColumnState } from 'ag-grid-community';

export interface GridState {
  columns: ColumnState[];
  filter: {
    [key: string]: any;
  };
}
